import { useEffect, useState } from 'react';
// True once the referenced element has scrolled into view (and stays true
// thereafter). Used to defer each property's availability-index call until its
// card is actually on screen, so a city/region search never fans out calls for
// properties the salesperson hasn't reached yet. Where IntersectionObserver is
// unavailable (jsdom, older runtimes) the element is treated as visible so the
// content still loads.
export const useOnScreen = (ref) => {
    const [onScreen, setOnScreen] = useState(false);
    useEffect(() => {
        if (onScreen) {
            return;
        }
        const element = ref.current;
        if (!element) {
            return;
        }
        if (typeof IntersectionObserver === 'undefined') {
            setOnScreen(true);
            return;
        }
        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
                setOnScreen(true);
            }
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, [ref, onScreen]);
    return onScreen;
};
